export class SelectList {
    key: String;
    value: String;

    constructor(key: String, value: String) {
        this.key = key;
        this.value = value;
    }
}
